import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';
import './service-request-timeslot-picker.scss';

const SKELETON_DAY_COLUMNS: number[] = [0, 1, 2];
const SKELETON_SLOTS_PER_DAY: number[] = [0, 1, 2, 3];

const TimeslotPickerSkeleton = () => {
  return (
    <div className="service-request-timeslot-picker">
      <div className="picker-title">Open timeslots</div>
      <div className="picker-week">
        {SKELETON_DAY_COLUMNS.map((column: number) => (
          <div key={column} className="picker-day-column">
            <div className="picker-day">
              <Skeleton variant="text" width="60%" />
            </div>
            <div className="picker-slots picker-slots-loading">
              {SKELETON_SLOTS_PER_DAY.map((row: number) => (
                <Skeleton
                  key={row}
                  variant="rect"
                  height={48}
                  className="picker-slot-skeleton"
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TimeslotPickerSkeleton;
